'use client'

import { useT } from '@/lib/useT'

const companies = [
  { name: 'Al Rajhi Industries', abbr: 'ARI' },
  { name: 'Gulf Horizon Group', abbr: 'GHG' },
  { name: 'Nile Ventures', abbr: 'NV' },
  { name: 'Emirates Capital', abbr: 'EC' },
  { name: 'Levant Tech', abbr: 'LT' },
  { name: 'Qamar Holdings', abbr: 'QH' },
  { name: 'Riyadh Solutions', abbr: 'RS' },
  { name: 'Masdar Innovate', abbr: 'MI' },
]

// Duplicate for seamless loop
const ticker = [...companies, ...companies]

export default function TrustedSection() {
  const t = useT()

  return (
    <section
      id="trusted"
      className="bg-[#FFF6E9] border-y border-[#E2E4E5] py-14 overflow-hidden"
      aria-label="Trusted by companies"
    >
      <div className="mx-auto max-w-[1200px] px-6 mb-10">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.12em] text-[#9EA2A5]">
          {t('trusted.heading')}
        </p>
      </div>

      {/* Ticker */}
      <div className="relative" aria-hidden="true">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#FFF6E9] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#FFF6E9] to-transparent" />

        <div className="ticker-track flex items-center gap-16 w-max">
          {ticker.map((company, i) => (
            <div key={`${company.abbr}-${i}`} className="flex items-center gap-3 shrink-0">
              {/* Logo placeholder block */}
              <div className="flex h-8 w-8 items-center justify-center rounded-[6px] bg-[#003F47]/8 text-[#003F47] text-[10px] font-bold tracking-wide shrink-0">
                {company.abbr}
              </div>
              <span className="text-sm font-semibold text-[#6C7377] whitespace-nowrap">
                {company.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Stats strip */}
      <div className="mx-auto max-w-[1200px] px-6 mt-12">
        <dl className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { value: '500+', label: 'Companies onboarded' },
            { value: '12', label: 'Countries active' },
            { value: '99.9%', label: 'Uptime SLA' },
            { value: '4.9/5', label: 'Average rating' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col items-center gap-1 text-center">
              <dt className="text-2xl font-bold text-[#003F47] tracking-tight">{stat.value}</dt>
              <dd className="text-xs text-[#6C7377] font-medium">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  )
}
